import { defineComponent as _defineComponent } from 'vue'
import './styles/page-header.scss';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageHeader',
  props: {
  title: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props;



return { __sfc: true,props }
}

})